import { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { changeUrlGivenCurrentQueryParams } from 'components/LinkWithQuery';

import KnowledgeGraphContainer from 'components/knowledgeGraph/KnowledgeGraphContainer';
import KnowledgeGraphSidebarWrapper from 'components/sidebar/KnowledgeGraphSidebar/KnowledgeGraphSidebarWrapper';
import HeaderButtonsModal from 'components/modals/HeaderButtonsModal/HeaderButtonsModal';

import { CloseButton, DiscoveryButton } from 'components/modals/HeaderButtonsModal/Buttons';

const KnowledgeGraphModal = ({ t, graph }) => {
  const history = useHistory();

  const closeModal = () => changeUrlGivenCurrentQueryParams(history, { showDialog: null });

  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      closeModal();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <HeaderButtonsModal
      leftButton={<DiscoveryButton />}
      title={t('tutorial.overview.knowledge-graph-title')}
      rightButton={<CloseButton />}
      // the two divs (KnowledgeGraphSidebarWrapper and KnowledgeGraph) are side-by-side, so we need to wrap them in a div
      // the KnowledgeGraphSidebarWrapper is the sidebar with the list of nodes and can overflow, in that case
      //  we need to style it so that it has a scrollbar. The KnowledgeGraph is the actual graph and should not have a scrollbar.
      content={
        <div style={{ display: 'flex', height: '100%' }}>
          <KnowledgeGraphSidebarWrapper />
          <KnowledgeGraphContainer graph={graph} isEmbedded={true} />
        </div>
      }
    />
  );
};

const mapStateToProps = state => ({ graph: state.graph });

export default withTranslation('veezoo')(connect(mapStateToProps)(KnowledgeGraphModal));
